import { useContext } from "react";
import { useMutation } from "react-query";
import AppContext from "./appContext";

import * as api from "./services";
import { logging } from "./tools";

export default function useErrorMutation() {
  const {
    app: {
      client: { id: clientId },
      sessionId,
    },
  } = useContext(AppContext);

  const errorMutation = useMutation(
    ({ errorMessage, stack, code }) =>
      api.postError({ clientId, sessionId, errorMessage, stack, code }),
    {
      onMutate: () => logging("ERROR POSTED"),
    }
  );
  return errorMutation;
}
